import { Paper, Skeleton } from "@mui/material";
import { STAT_CARD_MIN_HEIGHT } from "components/StatCard";
import { ReactNode } from "react";

import { StatCardGrid } from "../components/StatCardGrid";

/**
 * The card an Invoice Tracking summary sits on, above the list it describes.
 *
 * One component rather than a card per tab: the totals are the first thing a
 * reader sees on every tab, and three hand-rolled cards drifted apart on
 * padding and radius before this existed. Carries no outer margin — the caller
 * owns the gutter, because the same card is stacked differently on the invoice
 * detail page than it is above a grid.
 */
export function InvoiceTrackingSummaryCard({ children }: { children: ReactNode }) {
  return (
    <Paper elevation={0} sx={{ p: 3, borderRadius: 2 }}>
      {children}
    </Paper>
  );
}

/**
 * The summary's own loading state, laid out by the grid that will hold the real
 * tiles — so the totals arrive in place instead of shunting the list down the
 * page as they land.
 */
export function InvoiceTrackingSummarySkeleton({ count }: { count: number }) {
  return (
    <InvoiceTrackingSummaryCard>
      <StatCardGrid>
        {Array.from({ length: count }, (_, index) => (
          <Skeleton key={index} variant="rounded" height={STAT_CARD_MIN_HEIGHT} />
        ))}
      </StatCardGrid>
    </InvoiceTrackingSummaryCard>
  );
}
